<template>
    <Modal v-model="showModal" :title="`User Data: ${userName}`" footer-hide width="800">
        <div class="user-data-modal-content">
            <Tabs value="attendance">
                <TabPane label="Attendance (This Week)" name="attendance">
                    <div v-if="attendanceData.length > 0" style="height: 300px">
                        <LineChart :chartdata-labels="chartLabels" :chartdata-sets="chartDataSets" />
                    </div>
                    <div v-else-if="!loadingAttendance" style="text-align: center; padding: 20px">
                        No attendance data for this week.
                    </div>
                    <div style="margin-top: 10px; font-weight: bold">
                        Total Attendance: {{ attendanceData.length }} days
                    </div>
                </TabPane>
                <TabPane label="Leaves Consumed" name="leaves">
                    <Table :columns="leaveColumns" :data="leaveData" :loading="loadingLeaves" size="small"></Table>
                    <div style="margin-top: 10px; font-weight: bold">Total Leaves Consumed: {{ leaveData.length }}</div>
                </TabPane>
            </Tabs>
        </div>
    </Modal>
</template>

<script>
import moment from 'moment';
import { getPaginatedAttendanceRecordsPM } from '@/services/attendancelogs.services';
import { getEmployeeLeaves } from '@/components/Admin/LeaveSummary/services/leave-summary.service.ts';
import LineChart from '@/components/Graphs/LineChart';

export default {
    components: { LineChart },
    data() {
        return {
            showModal: false,
            userId: null,
            userName: '',
            loadingAttendance: false,
            loadingLeaves: false,
            attendanceData: [],
            leaveData: [],
            leaveColumns: [
                {
                    title: 'Date',
                    key: 'clockInTime',
                    render: (h, params) => {
                        return h('span', moment(params.row.clockInTime).utcOffset(8).format('DD-MMM-YYYY'));
                    },
                },
                {
                    title: 'Type',
                    key: 'status',
                },
            ],
        };
    },
    computed: {
        chartLabels() {
            return this.attendanceData.map((item) =>
                moment(item.clockInTime || item.createdAt)
                    .utcOffset(8)
                    .format('DD-MMM')
            );
        },
        chartDataSets() {
            const totalHoursData = this.attendanceData.map((item) => item.elapsedTimeInHrs || item.totalDailyHrs || 0);
            const clockInTimeData = this.attendanceData.map((item) => {
                if (!item.clockInTime) return null;
                const m = moment(item.clockInTime).utc();

                return m.hours() + m.minutes() / 60;
            });
            const statuses = this.attendanceData.map((item) => (item.status || '').toUpperCase());

            return [
                {
                    label: 'Clock In Time',
                    borderColor: 'rgba(255, 99, 132, 1)',
                    backgroundColor: 'transparent',
                    data: clockInTimeData,
                    yAxisID: 'y-axis-time',
                    type: 'line',
                    fill: false,
                    statuses: statuses,
                    pointBackgroundColor: this.attendanceData.map((item) => {
                        return item.status === 'late' ? 'rgba(255, 99, 132, 1)' : 'rgba(75, 192, 192, 1)';
                    }),
                    pointRadius: this.attendanceData.map((item) => (item.status === 'late' ? 6 : 3)),
                },
                {
                    label: 'Elapsed Time (Hrs)',
                    backgroundColor: 'rgba(75, 192, 192, 0.2)',
                    borderColor: 'rgba(75, 192, 192, 1)',
                    data: totalHoursData,
                    yAxisID: 'y-axis-hours',
                    type: 'bar',
                    statuses: statuses,
                },
            ];
        },
    },
    methods: {
        async openModal(user) {
            this.userId = user._id || user.id;
            this.userName = user.name;
            this.showModal = true;
            this.fetchAttendance();
            this.fetchLeaves();
        },
        async fetchAttendance() {
            this.loadingAttendance = true;
            try {
                const { data } = await getPaginatedAttendanceRecordsPM(this.userId);
                this.attendanceData = data;
            } catch (err) {
                console.error('Failed to fetch attendance', err);
            } finally {
                this.loadingAttendance = false;
            }
        },
        async fetchLeaves() {
            this.loadingLeaves = true;
            try {
                const res = await getEmployeeLeaves(this.userId);
                // Based on EmployeeLeaveHistory.vue: this.employeeLeaves = data[0].main[0].leaves;
                if (res.data && res.data[0] && res.data[0].main && res.data[0].main[0]) {
                    this.leaveData = res.data[0].main[0].leaves;
                }
            } catch (err) {
                console.error('Failed to fetch leaves', err);
            } finally {
                this.loadingLeaves = false;
            }
        },
    },
};
</script>

<style scoped>
.user-data-modal-content {
    padding: 10px 0;
}
</style>
